<cerrix-workspace
    [tabID]="tabID"
    [cerrixTab]="tab"
    [idProp]="'guid'"
    [data]="data"
    [headerLookup]="headerLookup"
    [module]="'object'"
    [moduleType]="moduleType"
    [moduleSubType]="moduleSubType"
    [appendToModuleType]="appendToModuleType"
    [permissions]="permissions"
    [filterConfig]="filterConfigs"
    [rendererConfig]="rendererConfig"
    [buttonConfig]="buttonConfig"
    [NumberProperties]="numberProps"
    (onDblClick)="openDetail($event)"
    (onAddClick)="add()"
>
</cerrix-workspace>
